import { CATEGORIES } from '../../../constants';

import useStyles from './styles';

export default function FontInfo({ displayCategoryName, font }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {displayCategoryName && (
        <p className={classes.category}>{CATEGORIES[font.mainCategory]?.text}</p>
      )}
      <p className={classes.name}>{font.name}</p>
    </div>
  );
}
